<div class="language-chooser" ipoClickOutside (clickOutside)="closeDropdown()">
  @if (language$ | async; as language) {
    @let selectedLanguage = getSelectedLanguage(language);

    <button
      type="button"
      class="dropdown-button"
      (click)="toggleDropdown()"
      (keyup.Escape)="closedByKey()"
      data-test-id="language-chooser"
    >
      <div class="selected-option">
        <img
          [src]="languageMap[selectedLanguage].icon"
          class="option-icon"
          [alt]="languageMap[selectedLanguage].label + ' icon'"
        />
        <span>{{ languageMap[selectedLanguage].label }}</span>
      </div>
    </button>

    @if (expanded) {
      <div class="dropdown-container">
        @for (option of languages; track option) {
          <div
            class="option"
            role="button"
            tabindex="0"
            data-test-id="test-option"
            (click)="onOptionClick($event, option)"
            (keydown.enter)="onOptionClick($event, option)"
          >
            <div class="selected-option">
              <img
                [src]="languageMap[option].icon"
                class="option-icon"
                [alt]="languageMap[option].label + ' icon'"
              />
              <span>{{ languageMap[option].label }}</span>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
